export const saveToLocalStorage = (data, key) => localStorage.setItem(key, data);
export const removeFromLocalStorage = (key) => localStorage.removeItem(key);
export const getFromLocalStorage = (key) => localStorage.getItem(key);
export const getFromLocalStorageAsync = async (key) => {
  const result = await localStorage.getItem(key);
  return result;
};
